import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ColumnsResponse, GenericDatabasePayload } from "../services/common/common.types";
import { commonService } from "../services/common/common.service";

export const useGetColumnsQuery = (
    payload: GenericDatabasePayload,
    options?: Omit<UseQueryOptions<ColumnsResponse[], Error>, 'queryKey' | 'queryFn'>
) => {
    return useQuery<ColumnsResponse[], Error>({
        queryKey: ['columns', payload],
        queryFn: () => commonService.getColumns(payload),
        staleTime: Infinity,
        gcTime: Infinity,
        retry: false,
        ...options,
    });
};